<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
	  <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
		  <el-form-item size="small">
    		  <el-input placeholder="请输入授权店铺" v-model="pinddquery.key" clearable @change="pinddquery.ischange=true"></el-input>
    	  </el-form-item>
		  <el-form-item size="small">
    			<el-button type="warning" size="small" icon="el-icon-search" round @click="getsettinglists">搜索</el-button>
				<el-button type="warning" size="small" round @click="addsettingshops">新增店铺</el-button>
    	  </el-form-item>
	  </el-form>

	  <div class="backborder2" style="margin-top:10px">
	    	<el-table :data="settinglists" v-loading="pinddquery.loading">
		        <el-table-column label="id" prop="id" min-width="120">
					<template slot-scope="scope">
						<div class="sell-type-main">{{scope.row.id}}</div>
					</template>
				</el-table-column>
				<el-table-column label="店铺名称" prop="name" min-width="200">
					<template slot-scope="scope">
						<div class="sell-type-main">{{scope.row.name}}</div>
					</template>
				</el-table-column>
				<el-table-column label="店铺账号" prop="name" min-width="200">
					<template slot-scope="scope">
						<div class="sell-type-main">{{scope.row.owner_id+'（平台：拼多多）'}}</div>
					</template>
				</el-table-column>
				<el-table-column label="到期时间" prop="name" min-width="200">
					<template slot-scope="scope">
						<div class="sell-type-main">{{scope.row.expire_time}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" prop="name" min-width="200" align="center">
					<template slot-scope="scope">
						<el-button type="warning" size="small" round @click="gotogrant(scope.row)">{{scope.row.code=='' ? '去授权' : '重新授权'}}</el-button>
					</template>
				</el-table-column>
	      	</el-table>
	      	<div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="orderPageSizeChange"
		            @current-change="orderPageCurrentChange"
		            :current-page="pinddquery.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="pinddquery.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="pinddquery.rows">
	            </el-pagination>
	            <!--分页end-->
	      	</div>
    	</div>



		<!-- 新增店铺 -->
		<el-dialog title="新增店铺" :visible.sync="addshops.dialog" width="25%">
			<el-form >
				<el-form-item label="店铺名称" label-width="140">
    				<el-input placeholder="请输入店铺名称" v-model="addshops.name" clearable  style="width:auto"/>
    			</el-form-item>
				<el-form-item label="店铺账号" label-width="140">
    				<el-input placeholder="请输入店铺账号" v-model="addshops.owner_id" clearable style="width:auto"/>
    			</el-form-item>
			</el-form>
			 <div slot="footer" class="dialog-footer">
	            <el-button size="medium" @click="addshops.dialog = false">取 消</el-button>
	            <el-button size="medium" type="primary" :loading="addshops.loading" @click="addSave">添加</el-button>
	        </div>	     
		</el-dialog>


    
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Pindd/index",
      transitionshow:true,
      actionauth:[],
	  pinddquery: {
		  act:'getsettinglists',
		  token:this.$cookies.get('token'),
		  key:'',
		  loading:false,
		  ischange:false,
		  p:1,
		  rollpage:10,
		  rows:0,
	  },
	  settinglists:[],

	  addshops: {
		  act:'addshops',
		  token:this.$cookies.get('token'),
		  name:'',
		  owner_id:'',
		  dialog:false,
		  loading:false,
	  },
	  
      
    }
  },
  
  
  mounted(){
      //this.getactionauth(); //获取权限设置
	  this.getsettinglists(); //获取设置列表
  },
  
  methods:{


	  //新增店铺信息
	  addsettingshops() {
		  this.addshops.name='';
		  this.addshops.owner_id='';
		  this.addshops.dialog=true;
	  },

	  //保存店铺信息
	  addSave() {
			this.addshops.loading=true;
		    var resource = this.$resource(this.url);
			resource.save(this.addshops).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.addshops.loading=false;
				}else{
					this.addshops.dialog=false;
					this.addshops.loading=false;
					this.getsettinglists();
				}
			}).catch((res) => {
				//this.$message.error(this.GLOBAL.errortext);
				this.addshops.loading=false;
			});
	  },

	
	  //获取授权店铺信息
	  getsettinglists() {
		  	if(this.pinddquery.ischange) {
				this.pinddquery.p=1;
				this.pinddquery.rollpage=10;
			}

			this.pinddquery.loading=true;
		    var resource = this.$resource(this.url);
			resource.query(this.pinddquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.pinddquery.loading=false;
				}else{
					this.settinglists = JSON.parse(Base64.decode(res.data.Data));
	            	this.pinddquery.rows=parseInt(res.data.count);
					this.pinddquery.loading=false;
					this.pinddquery.ischange ? this.pinddquery.ischange=false : '';
				}
			}).catch((res) => {
				//this.$message.error(this.GLOBAL.errortext);
				this.pinddquery.loading=false;
			});
	  },


	  orderPageSizeChange(val) {
        this.pinddquery.rollpage = val;
        this.getsettinglists();
     },
     orderPageCurrentChange(val) {
        this.pinddquery.p = val;
        this.getsettinglists();
     },



	  //店铺信息去授权
	  gotogrant(item) {
		  let url="https://fuwu.pinduoduo.com/service-market/auth?";
		  url+="response_type=code";
		  url+="&client_id="+item.clientId;
		  url+="&redirect_uri=http://dealer20.chonglaoban.cn/PinddInterface/Callback";
		  url+="&state="+item.id;
		  window.open(url);
	  },


  }


}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.cz-pindd-setting-infos {display:inline-block;padding:20px;width:calc((100% - 200px - 80px)/3);height:370px;border-radius:12px;margin-top:20px;background:#ed435b;transition:.3s all;position:relative;}
.cz-pindd-setting-infos:nth-child(even) {margin-left:20px;margin-right:20px;}
.cz-pindd-setting-infos:hover {box-shadow:3px 3px 10px #666666;}
.cz-pindd-setting-infos img {width:50px;height:50px;margin-left:calc((100% - 50px)/2);}
.cz-pindd-setting-main {display:inline-block;width:100%;height:calc(100% - 50px - 10px);margin-top:10px;}
.cz-pindd-form .el-form-item__label {color:#fff;font-weight:300;}
.cz-pindd-form .el-form-item__content {width:calc(100% - 90px - 10px);margin-left:100px !important;}
.cz-pindd-setting-infos-title {display:inline-block;width:100%;font-size:14px;text-align:center;color:#fff;font-weight:200;letter-spacing:3px;}
</style>


// WEBPACK FOOTER //
// src/components/Pindd/PinddSettings.vue